module.exports = __webpack_public_path__ + "img/work.de871d91.png";